var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHungary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.847,
    height: 37.848,
    viewBox: "0 0 37.847 37.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .a {\n                fill: #f0f0f0;\n            }\n\n            .b {\n                fill: #fa0b54;\n            }\n\n            .c {\n                fill: #84c654;\n            }\n\n            .d {\n                filter: url(#a);\n            }\n        "), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 37.847,
    height: 37.848,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.539 5.539)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "matrix(1, 0, 0, 1, -8.54, -5.54)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 9.923,
    cy: 9.924,
    rx: 9.923,
    ry: 9.924,
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.359)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.632,145.579a10.191,10.191,0,0,0,0,7.063l9.522.883,9.522-.883a10.191,10.191,0,0,0,0-7.063l-9.522-.883Z",
    transform: "translate(0 -148.957)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M25.446,0a10.157,10.157,0,0,0-9.522,6.622H34.969A10.158,10.158,0,0,0,25.446,0Z",
    transform: "translate(-15.292 -10)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M25.446,351.665a10.157,10.157,0,0,0,9.522-6.622H15.924A10.157,10.157,0,0,0,25.446,351.665Z",
    transform: "translate(-15.292 -341.357)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHungary);
export default __webpack_public_path__ + "static/media/hungary.9bfced80131c7154619884e3f5add001.svg";
export { ForwardRef as ReactComponent };